import React from 'react';
import ReactSelect, { components } from 'react-select';
import { Container, Label, LabelContainer, SingleValueText, selectStyles } from './SelectAlt.styles';
import ErrorContainer from '../ErrorContainer/ErrorContainer';

const { Option, SingleValue, NoOptionsMessage } = components;

const SelectAlt = ({
  label,
  selectedOption,
  options,
  handleChange,
  isSearchable,
  placeholder,
  error,
  multiSelection,
  disabled,
  className,
  isClearable,
  hideError,
}) => {
  return (
    <Container>
      {label && (
        <LabelContainer>
          <Label>{label}</Label>
        </LabelContainer>
      )}
      <ReactSelect
        styles={selectStyles}
        className={className}
        options={options}
        value={selectedOption}
        onChange={handleChange}
        closeMenuOnSelect={!multiSelection}
        isMulti={multiSelection}
        isDisabled={disabled}
        isSearchable={isSearchable}
        isClearable={isClearable}
        placeholder={placeholder}
        placeholderTextColor="#fff"
        components={{
          Option: props => IconOption(props),
          SingleValue: props => IconSingleValue(props),
          NoOptionsMessage: props => NoOptionsMessageComponent(props),
        }}
      />
      {!hideError && <ErrorContainer errorText={error} />}
    </Container>
  );
};

const IconOption = props => {
  return (
    <Option {...props}>
      {props.data.icon}
      <SingleValueText>{props.data.label}</SingleValueText>
    </Option>
  );
};

const IconSingleValue = props => {
  return (
    <SingleValue {...props}>
      {props.data.icon}
      <SingleValueText>{props.data.label}</SingleValueText>
    </SingleValue>
  );
};

const NoOptionsMessageComponent = props => {
  return (
    <NoOptionsMessage {...props}>
      <SingleValueText>{props.children}</SingleValueText>
    </NoOptionsMessage>
  );
};

export default SelectAlt;
